export const
    GooglePlay = "Google Play",
    EmailChannel = "Email",
    FacebookPage = "Página do Facebook",
    YouTubeChannel = "Canal do YouTube";